/* eslint-disable max-len */
/* eslint-disable no-plusplus */
// libraries
import React from 'react';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import {
    CheckCircle, Edit, NavigateBefore, Send,
} from '@material-ui/icons';
import { v4 as uuidv4 } from 'uuid';

// js
import defaultSound from '../../../assets/images/defaultSound.png';
import imgDefault from '../../../assets/images/default.png';
import { allMenuItems } from './taskConstants';
import {
    ContainerAdjustIconEdit,
    ContainerOptions,
    InputNullSelectedPhoto,
    Logo,
    TitleOption,
} from '../modulesStyles';

// interfaces
import type { ConnectPhrases, DataModuleInterface } from '../modulesInterfaces';
import uploads from '../../../services/uploads';
import tasks from '../../../services/tasks';

const TaskConnectPhrasesToImages = (
    setIdModal: any,
    initialDataTaskConnectPhrases: ConnectPhrases,
    taskConnectPhrasesToImages: ConnectPhrases,
    setTaskConnectPhrasesToImages: any,
    dataModule: DataModuleInterface,
) => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');
    const adjustMarginBottom = { marginBottom: 10 };
    const adjustButtonLogo = { marginBottom: 25, width: 200 };
    const adjustWidthSelectedActivities = { width: 200 };

    // methods
    const BackScreenModal = () => {
        setIdModal(1);
        setTaskConnectPhrasesToImages(initialDataTaskConnectPhrases);
    };

    const CreateTask = async () => {
        const formatOptions = taskConnectPhrasesToImages?.options?.map((e: any) => {
            const option = e;
            delete option.idWrapperTask;
            return option;
        });
        const formatTask: any = {
            ...taskConnectPhrasesToImages,
            options: formatOptions,
            idTask: taskConnectPhrasesToImages.id,
            idModule: dataModule?.id,
        };
        delete formatTask?.id;
        if (formatTask?.idTask) {
            const editTask: any = await tasks.EditTask(formatTask, token);
            if (editTask) {
                BackScreenModal();
            }
        } else {
            delete formatTask?.idTask;
            const createTask: any = await tasks.CreateTask(formatTask, token);
            if (createTask) {
                BackScreenModal();
            }
        }
    };

    const onChangeTitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskConnectPhrasesToImages, title: txt.target.value };
            setTaskConnectPhrasesToImages(newDataTask);
        }
    };

    const onChangeSubtitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskConnectPhrasesToImages, subtitle: txt.target.value };
            setTaskConnectPhrasesToImages(newDataTask);
        }
    };

    const onChangeOptionSkipTask = (txt: any) => {
        const newDataTask = { ...taskConnectPhrasesToImages, skip: txt.target.value };
        setTaskConnectPhrasesToImages(newDataTask);
    };

    const validationDisabled = () => {
        let valueObject = true;
        const ValidationOptionsLength = taskConnectPhrasesToImages?.options.filter((v: any) => v.fileImgEnglish && v.fileImgPortuguese && v.fileAudio).length === taskConnectPhrasesToImages?.options?.length;
        if (taskConnectPhrasesToImages?.id) {
            const ValidationLength = Object.values(taskConnectPhrasesToImages).filter((v) => v !== '').length !== 7;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        } else if (!taskConnectPhrasesToImages?.id) {
            const ValidationLength = Object.values(taskConnectPhrasesToImages).filter((v) => v !== '').length !== 6;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        }
        return valueObject;
    };

    const validationBackground = () => {
        const valueObject = Object.values(taskConnectPhrasesToImages).filter((v) => v !== '');
        const ValidationOptionsLength = taskConnectPhrasesToImages?.options.filter((v: any) => v.fileImgEnglish && v.fileImgPortuguese && v.fileAudio).length === taskConnectPhrasesToImages?.options?.length;
        if ((taskConnectPhrasesToImages?.id ? valueObject.length === 7 : valueObject.length === 6) && ValidationOptionsLength) {
            return 'primary';
        }

        return 'inherit';
    };

    const onChangeTarget = (txt: any) => {
        const allOptions = [];
        for (let i = 0; i < Number(txt.target.value); i++) {
            const objOrigin = {
                id: uuidv4(),
                fileImgEnglish: '',
                fileImgPortuguese: '',
                fileAudio: '',
            };
            allOptions.push(objOrigin);
            if (allOptions.length === Number(txt.target.value)) {
                const orderNewDataOption = allOptions.sort((a, b) => {
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    return 0;
                });
                const newDataTask = {
                    ...taskConnectPhrasesToImages,
                    target: Number(txt.target.value),
                    options: orderNewDataOption,
                };
                setTaskConnectPhrasesToImages(newDataTask);
            }
        }
    };

    // renders
    const RenderInputsBody = () => {
        if (taskConnectPhrasesToImages.options?.length) {
            return taskConnectPhrasesToImages.options.map((item: any) => {
                const [getOneOption] = taskConnectPhrasesToImages.options.filter(
                    (v: any) => v.id === item.id,
                );
                const removeOneOption = taskConnectPhrasesToImages.options.filter(
                    (v: any) => v.id !== item.id,
                );

                const SelectedAudio = async (event: any) => {
                    if (event.target.files.length) {
                        const newDataFiles = {
                            eventFile: event.target.files[0],
                            eventName: event.target.files[0].name,
                            file: URL.createObjectURL(event.target.files[0]),
                        };

                        const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                        if (upload) {
                            const optionModified = {
                                id: getOneOption.id,
                                fileAudio: upload.result,
                                fileImgEnglish: getOneOption.fileImgEnglish,
                                fileImgPortuguese: getOneOption.fileImgPortuguese,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskConnectPhrasesToImages({
                                ...taskConnectPhrasesToImages,
                                options: orderNewDataOption,
                            });
                            // eslint-disable-next-line no-param-reassign
                            event.target.value = null;
                        }
                    }
                };

                const SelectedPhotoPortuguese = async (event: any) => {
                    if (event.target.files.length) {
                        const newDataFiles = {
                            eventFile: event.target.files[0],
                            eventName: event.target.files[0].name,
                            file: URL.createObjectURL(event.target.files[0]),
                        };

                        const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                        if (upload && getOneOption.id === item.id) {
                            const optionModified = {
                                fileAudio: getOneOption.fileAudio,
                                fileImgEnglish: getOneOption.fileImgEnglish,
                                fileImgPortuguese: upload.result,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskConnectPhrasesToImages({
                                ...taskConnectPhrasesToImages,
                                options: orderNewDataOption,
                            });
                            // eslint-disable-next-line no-param-reassign
                            event.target.value = null;
                        }
                    }
                };

                const SelectedPhotoEnglish = async (event: any) => {
                    if (event.target.files.length) {
                        const newDataFiles = {
                            eventFile: event.target.files[0],
                            eventName: event.target.files[0].name,
                            file: URL.createObjectURL(event.target.files[0]),
                        };

                        const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                        if (upload && getOneOption.id === item.id) {
                            const optionModified = {
                                fileAudio: getOneOption.fileAudio,
                                fileImgEnglish: upload.result,
                                fileImgPortuguese: getOneOption.fileImgPortuguese,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskConnectPhrasesToImages({
                                ...taskConnectPhrasesToImages,
                                options: orderNewDataOption,
                            });
                            // eslint-disable-next-line no-param-reassign
                            event.target.value = null;
                        }
                    }
                };

                return (
                    <ContainerOptions marginTop="10px">
                        <Button
                            style={adjustButtonLogo}
                            title={item?.fileImgPortuguese}
                        >
                            <Logo src={item?.fileImgPortuguese || imgDefault} />
                            <ContainerAdjustIconEdit right="5px">
                                <Edit color="primary" />
                            </ContainerAdjustIconEdit>
                            <InputNullSelectedPhoto
                                accept="image/png, image/jpeg, image/jpg"
                                onChange={SelectedPhotoPortuguese}
                                type="file"
                            />
                        </Button>
                        <Button
                            style={adjustButtonLogo}
                            title={item?.fileImgEnglish}
                        >
                            <Logo src={item?.fileImgEnglish || imgDefault} />
                            <ContainerAdjustIconEdit right="5px">
                                <Edit color="primary" />
                            </ContainerAdjustIconEdit>
                            <InputNullSelectedPhoto
                                accept="image/png, image/jpeg, image/jpg"
                                onChange={SelectedPhotoEnglish}
                                type="file"
                            />
                        </Button>
                        <Button
                            style={adjustButtonLogo}
                            title={item?.fileAudio}
                        >
                            <Logo src={defaultSound} />
                            {item?.fileAudio ? (
                                <ContainerAdjustIconEdit right="7px" style={adjustMarginBottom}>
                                    <CheckCircle color="inherit" />
                                </ContainerAdjustIconEdit>
                            ) : null}
                            <InputNullSelectedPhoto
                                accept=".mp3,audio/*"
                                onChange={SelectedAudio}
                                type="file"
                            />
                        </Button>
                    </ContainerOptions>
                );
            });
        }

        return null;
    };

    const RenderSelectedSkipTask = () => {
        const optionsEnglish = taskConnectPhrasesToImages.options.filter((v: any) => v.fileImgEnglish !== '').length;
        const optionsPortuguese = taskConnectPhrasesToImages.options.filter((v: any) => v.fileImgPortuguese !== '').length;
        const optionsFile = taskConnectPhrasesToImages.options.filter((v: any) => v.fileAudio).length;
        const allOptionsConnectPhrases = optionsEnglish + optionsPortuguese + optionsFile;
        const allOptions = allOptionsConnectPhrases === taskConnectPhrasesToImages.target * 3;

        if (optionsEnglish + optionsPortuguese > 0 && allOptions) {
            return (
                <FormControl style={adjustWidthSelectedActivities}>
                    <InputLabel>Pular/Não pular</InputLabel>
                    <Select value={taskConnectPhrasesToImages.skip} onChange={onChangeOptionSkipTask}>
                        <MenuItem value="true">Pular</MenuItem>
                        <MenuItem value="false">Não pular</MenuItem>
                    </Select>
                </FormControl>
            );
        }

        return null;
    };

    const RenderAllItems = () => {
        if (allMenuItems.ids.length) {
            return allMenuItems.ids.map((idSelected: any) => (
                <MenuItem value={idSelected}>{idSelected}</MenuItem>
            ));
        }
        return null;
    };

    const RenderInputsTitles = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <>
                <ContainerOptions marginTop="10px" />
                <TextField
                    fullWidth
                    label={`${label} (${ValueActual.length}/200)`}
                    onChange={onChange}
                    value={value}
                />
            </>
        );
    };

    const EndIcon = () => (
        <Send />
    );

    const RenderIconGoBack = () => (
        <NavigateBefore />
    );

    return (
        <>
            <ContainerOptions>
                <TitleOption width="100%">Criação da Atividade - Associe imagens relacionadas</TitleOption>
            </ContainerOptions>
            {RenderInputsTitles('Título da atividade', taskConnectPhrasesToImages.title, onChangeTitle)}
            {RenderInputsTitles('Subtítulo da atividade', taskConnectPhrasesToImages.subtitle, onChangeSubtitle)}
            <FormControl style={adjustWidthSelectedActivities}>
                <InputLabel>Quantidade</InputLabel>
                <Select value={taskConnectPhrasesToImages.target} onChange={onChangeTarget}>
                    {RenderAllItems()}
                </Select>
            </FormControl>
            {RenderInputsBody()}
            {RenderSelectedSkipTask()}
            <ContainerOptions marginTop="40px">
                <Button
                    color="primary"
                    startIcon={RenderIconGoBack()}
                    onClick={BackScreenModal}
                    variant="contained"
                >
                    Voltar
                </Button>
                <Button
                    color={validationBackground()}
                    disabled={validationDisabled()}
                    endIcon={EndIcon()}
                    onClick={CreateTask}
                    variant="contained"
                >
                    {taskConnectPhrasesToImages?.id ? 'Editar Atividade' : 'Criar Atividade'}
                </Button>
            </ContainerOptions>
        </>
    );
};

export default TaskConnectPhrasesToImages;
